var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertyTypeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.476,
    height: 30.13,
    viewBox: "0 0 30.476 30.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_34",
    "data-name": 34,
    transform: "translate(0 -0.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "translate(0 0.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4761",
    "data-name": "Path 4761",
    d: "M14.135,9.09l11.187,2.222a1.876,1.876,0,0,1,1.511,1.854V26.118a1.9,1.9,0,0,1-1.9,1.9H13.5a.629.629,0,0,0,.635-.635v-.635H24.928a.637.637,0,0,0,.635-.635V13.166a.638.638,0,0,0-.5-.622L14.135,10.385Z",
    transform: "translate(3.643 2.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4762",
    "data-name": "Path 4762",
    d: "M20.175,14a.635.635,0,0,1,0,1.27h-2.54a.635.635,0,0,1,0-1.27Z",
    transform: "translate(4.587 3.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4763",
    "data-name": "Path 4763",
    d: "M20.175,17a.635.635,0,0,1,0,1.27h-2.54a.635.635,0,0,1,0-1.27Z",
    transform: "translate(4.587 4.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4764",
    "data-name": "Path 4764",
    d: "M20.175,20a.635.635,0,0,1,0,1.27h-2.54a.635.635,0,0,1,0-1.27Z",
    transform: "translate(4.587 5.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4765",
    "data-name": "Path 4765",
    d: "M14.27,27.412a.635.635,0,1,1-1.27,0V9.635a.675.675,0,0,1,.229-.5.667.667,0,0,1,.533-.127l.508.1v18.3Z",
    transform: "translate(3.508 2.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4766",
    "data-name": "Path 4766",
    d: "M13.944,23v.635a.629.629,0,0,0,.635.635H9.5a.629.629,0,0,0,.635-.635V23Z",
    transform: "translate(2.563 5.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4767",
    "data-name": "Path 4767",
    d: "M11.175,5a.635.635,0,1,1,0,1.27H8.635a.635.635,0,1,1,0-1.27Z",
    transform: "translate(2.159 1.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4768",
    "data-name": "Path 4768",
    d: "M11.809,8.635a.629.629,0,0,1-.635.635H8.635a.635.635,0,1,1,0-1.27h2.54A.629.629,0,0,1,11.809,8.635Z",
    transform: "translate(2.159 1.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4769",
    "data-name": "Path 4769",
    d: "M11.175,11a.635.635,0,1,1,0,1.27H8.635a.635.635,0,1,1,0-1.27Z",
    transform: "translate(2.159 2.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4770",
    "data-name": "Path 4770",
    d: "M11.175,14a.635.635,0,1,1,0,1.27H8.635a.635.635,0,1,1,0-1.27Z",
    transform: "translate(2.159 3.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4771",
    "data-name": "Path 4771",
    d: "M6.809,14.635a.629.629,0,0,1-.635.635H3.635a.635.635,0,1,1,0-1.27h2.54A.629.629,0,0,1,6.809,14.635Z",
    transform: "translate(0.809 3.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4772",
    "data-name": "Path 4772",
    d: "M6.175,5a.635.635,0,0,1,0,1.27H3.635a.635.635,0,1,1,0-1.27Z",
    transform: "translate(0.809 1.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4773",
    "data-name": "Path 4773",
    d: "M6.175,8a.635.635,0,0,1,0,1.27H3.635a.635.635,0,1,1,0-1.27Z",
    transform: "translate(0.809 1.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4774",
    "data-name": "Path 4774",
    d: "M6.175,11a.635.635,0,1,1,0,1.27H3.635a.635.635,0,1,1,0-1.27Z",
    transform: "translate(0.809 2.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4775",
    "data-name": "Path 4775",
    d: "M10.349,18.9a.637.637,0,0,0-.635-.635H5.9a.629.629,0,0,0-.635.635v5.714H4V18.9A1.9,1.9,0,0,1,5.9,17H9.714a1.9,1.9,0,0,1,1.9,1.9v5.714h-1.27Z",
    transform: "translate(1.079 4.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4776",
    "data-name": "Path 4776",
    d: "M5.27,23h6.349v.635a.629.629,0,0,1-.635.635H4.635A.629.629,0,0,1,4,23.635V23Z",
    transform: "translate(1.079 5.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M2.222.205,16.177,2.318a1.893,1.893,0,0,1,1.6,1.872V11.45l-.508-.1a.625.625,0,0,0-.762.62V4.19a.64.64,0,0,0-.533-.632L2.019,1.457A.353.353,0,0,0,1.9,1.445.6.6,0,0,0,1.5,1.6a.6.6,0,0,0-.229.481V28.413a.636.636,0,0,0,.635.632H5.079v.632a.628.628,0,0,0,.635.632H1.9a1.9,1.9,0,0,1-1.9-1.9V2.077A1.86,1.86,0,0,1,.673.635,1.911,1.911,0,0,1,2.222.205Z",
    transform: "translate(0 -0.181)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyTypeIcon);
export default __webpack_public_path__ + "static/media/property-type-icon.7fdfd3a3d912d7aacbb2e7db55a36638.svg";
export { ForwardRef as ReactComponent };